export function deliveryLabel(status) {
  return ({sent:"accepté par le fournisseur · réception non confirmée",delivered:"disponible dans l’application",failed:"échec · réception non confirmée",not_configured:"canal non configuré",not_linked:"compte non lié",no_user:"destinataire introuvable"})[status]||"résultat inconnu · réception non confirmée";
}
